var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExportChecklistTemplates = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 101,
  height: 100,
  viewBox: "0 0 101 100"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M50.5 98c26.51 0 48-21.49 48-48S77.01 2 50.5 2s-48 21.49-48 48 21.49 48 48 48m0 2c-27.614 0-50-22.386-50-50s22.386-50 50-50 50 22.386 50 50-22.386 50-50 50"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.037 54.514q3.353 3.353 3.353 8.093c0 4.74-1.117 5.856-3.353 8.092q-3.353 3.353-8.092 3.353t-8.092-3.353Q48.5 67.345 48.5 62.607q0-4.74 3.353-8.093t8.092-3.353q4.74 0 8.092 3.353m-1.454 14.774q2.773-2.773 2.773-6.68t-2.752-6.659-6.659-2.752-6.659 2.752-2.752 6.659 2.752 6.68 6.659 2.773 6.638-2.773"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M63.815 65.135c.187.234.283.51.283.81s-.096.577-.337.868c-.54.494-1.178.494-1.69-.018l-2.682-2.723h-.041l-.15-.15a1.2 1.2 0 0 1-.363-.873v-6.285a1.17 1.17 0 0 1 1.194-1.194c.33 0 .625.115.852.342s.342.52.342.852v5.815z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m49.387 25.948 11.908 11.908v10.49h-2.357v-7.198H46.275V28.33h-9.987v33.342h9.224v2.381h-9.224q-.968 0-1.674-.707-.708-.707-.707-1.674V28.33q0-.968.707-1.675.706-.707 1.674-.707zm9.447 13.068L48.418 28.33h-.222v10.913h10.638z"
}))));
export default SvgExportChecklistTemplates;